import { useEffect } from "react";
import TagManager from "react-gtm-module";
import { useLocation } from "react-router-dom";

const useGTMTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: "pageview",
        page: pathname,
      },
    });
  }, [pathname]);
};

export default useGTMTracker;
